import { FormControlLabel, Switch, type FormControlLabelProps, type SwitchProps } from '@mui/material';
import type { ReactNode } from 'react';

export type HFSwitchProps = Omit<SwitchProps, 'onChange'> & {
  label?: ReactNode;
  labelPlacement?: FormControlLabelProps['labelPlacement'];
  onChange?: (checked: boolean) => void;
};

export function HFSwitch({ label, labelPlacement = 'end', onChange, ...props }: HFSwitchProps) {
  const control = <Switch color="primary" {...props} onChange={(_, checked) => onChange?.(checked)} />;
  if (label == null) return control;
  return (
    <FormControlLabel
      control={control}
      label={label}
      labelPlacement={labelPlacement}
      sx={
        labelPlacement === 'start'
          ? {
              m: 0,
              width: '100%',
              justifyContent: 'space-between',
              gap: 2,
              '& .MuiFormControlLabel-label': { flex: 1 },
            }
          : undefined
      }
    />
  );
}
